
export const absenceActionNameValues = [{name: 'AbsenceSwitchboardNumber', forwardingTarget: 4}, {
  name: 'AbsenceSecretaryNumber', forwardingTarget: 3
}, {name: 'AbsenceUCCFNumber', forwardingTarget: 5}];

export const absenceDuration = [{text: 'duration.30_minutes', key: '30'}, {text: 'duration.1_hour', key: '60'},
  {text: 'duration.1.5_hours', key: '90'}, {text: 'duration.2_hours', key: '120'}, {text: 'duration.3_hours', key: '180'},
  {text: 'duration.4_hours', key: '240'}, {text: 'duration.day_off', key: '00:00'}, {text: 'duration.1_week', key: '23:59+7'},
  {text: 'duration.2_weeks', key: '23:59+14'}];

export const absenceActions = [{text: 'action.call_me_as_usual', key: 1}, { text: 'action.my_service', key: 2},
  {text: 'action.colleague', key: 3}, {text: 'action.main_number', key: 4},
  {text: 'action.other_number', key: 5}, {text: 'action.voice_mail', key: 6}];

export const forwardingTypes = [{text: 'forwarding.after', key: 0}, {text: 'forwarding.immediately', key: 4},
  {text: 'forwarding.none', key: 9}];

export const forwardingTargets = [{text: 'action.colleague', key: 2}, {text: 'action.main_number', key: 3},
  {text: 'action.other_number', key: 4}, {text: 'action.voice_mail', key: 1}];

export const forwardingTargetNameValues = [{name: 'SwitchboardNumber', forwardingTarget: 3}, {name: 'SecretaryNumber', forwardingTarget: 2},
  {name: 'UCCFNumber', forwardingTarget: 4}];
